import "./templete.css";
import React from "react";
// import "./template.css";

export default function PodcastCard({ guestImage, firstName, lastName }) {
  const first = firstName || "";
  const last = lastName || "";

  // ==============================
  // FIRST NAME FONT SIZE
  // ==============================

  const getFirstNameFontSize = (name) => {
    const length = name.length;

    if (length <= 8) {
      return 100;
    }

    if (length <= 10 && length > 8) {
      return 75;
    }

    if (length <= 12 && length > 10) {
      return 65;
    }

    if (length <= 14) {
      return 55;
    }

    // if (length <= 16) {
    //   return 60;
    // }

    return 55;
  };

  const firstNameFontSize = getFirstNameFontSize(first);

  // const lastNameFontSize = getLastNameFontSize(last);
  const lastNameFontSize = firstNameFontSize * 0.6;

  return (
    <div>
      <div className="cardNew">
        <img
          src={guestImage || null}
          alt="Guest"
          className="guest-image"
          crossOrigin="anonymous"
        />

        <img
          src="https://res.cloudinary.com/bsgfcooa/image/upload/v1785157209/new_Brand_yc1fht.png"
          alt="Template"
          className="overlay-image"
          crossOrigin="anonymous"
        />

        <div className="guest-name">
          <span
            className="first-name"
            style={{
              fontSize: `${firstNameFontSize}px`,
            }}
          >
            {firstName || ""}
          </span>

          <span
            className="last-name"
            style={{
              fontSize: `${lastNameFontSize}px`,
            }}
          >
            {lastName || ""}
          </span>
        </div>
      </div>
    </div>
  );
}
